import {
  DELETE_PLC_SAFETY_ZONE_DEPENDENCY,
  DELETE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL,
  DELETE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED,
} from './actionTypes';

export const deletePlcSafetyZoneDependency = (zoneDependency) => ({
  type: DELETE_PLC_SAFETY_ZONE_DEPENDENCY,
  payload: { zoneDependency },
});

export const deletePlcSafetyZoneDependencySuccessful = (message) => ({
  type: DELETE_PLC_SAFETY_ZONE_DEPENDENCY_SUCCESSFUL,
  payload: message,
});

export const deletePlcSafetyZoneDependencyFailed = (message) => ({
  type: DELETE_PLC_SAFETY_ZONE_DEPENDENCY_FAILED,
  payload: message,
});
